import { BASE_API_URL } from './constants';
import axiosAuthoringInstance from './constants';
import axios from 'axios';

export const loginUser = (email, password) => {
  return axios
    .post(`${BASE_API_URL}/auth/login/`, {
      email: email,
      password: password,
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const createUser = data => {
  return axios
    .post(`${BASE_API_URL}/auth/signUp/`, {
      email: data.email,
      password: data.password,
      first_name: data.firstName,
      last_name: data.lastName,
      phone_number: data.phoneNumber,
      company_position: data.companyPosition,
      company: data.company,
      country: data.country,
      available_services: data.availableServices,
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const importSDS = (sdsId, language = '') => {
  const params = { sds_id: sdsId };
  if (language) params.language = language;
  return axiosAuthoringInstance
    .post('/sdsAuthoring/utils/import/', params)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const importSDSFile = (
  file,
  requestUUID,
  fromPage,
  toPage,
  privateImport
) => {
  let data = new FormData();
  data.append('id', requestUUID);
  if (fromPage) {
    data.append('from_page', fromPage);
  }
  if (toPage) {
    data.append('to_page', toPage);
  }
  if (privateImport) {
    data.append('private_import', privateImport);
  }
  if (file && file.length > 0)
    file.map(item => data.append('imported_file', item));

  return axiosAuthoringInstance
    .post('/sdsAuthoring/utils/importSDSFile/', data, {
      timeout: 10800000,
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const translateString = data => {
  return axiosAuthoringInstance
    .post('/sdsAuthoring/utils/translate/', data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const createSupplierInfo = data => {
  return axiosAuthoringInstance
    .post('/sdsAuthoring/supplierInfo/', data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const createManufacturerInfo = data => {
  return axiosAuthoringInstance
    .post('/sdsAuthoring/manufacturerInfo/', data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const approveSdsFile = sdsId => {
  return axiosAuthoringInstance
    .post(`/sdsAuthoring/files/${sdsId}/approve/`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const removeApprovalSdsFile = sdsId => {
  return axiosAuthoringInstance
    .post(`/sdsAuthoring/files/${sdsId}/removeApprove/`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const createSdsComponent = data => {
  return axiosAuthoringInstance
    .post('/sdsAuthoring/customerComponents/', data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const sendEmail = data => {
  return axiosAuthoringInstance
    .post('/sdsAuthoring/utils/sendEmail/', data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const copySdsData = (sdsId, data = {}) => {
  return axiosAuthoringInstance
    .post(`/sdsAuthoring/files/${sdsId}/copy/`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const regenerateSdsFdfFile = (sdsId) => {
  return axiosAuthoringInstance
    .post(`/sdsAuthoring/files/${sdsId}/regenerateFdfFile/`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}